import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PollIcon(props: IconProps) {
    return <Icon {...props} iconKey={"poll"}/>
}
